import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { DealerReportThreshold } from "models";

const component = "DealerOverviewDashboard";

export const DealerOverviewDashboardQueryKeys = {
  thresholds: (dealer_id?: number) =>
    backendQueryKey<DealerReportThreshold[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/dealers/thresholds/list", params: { dealer_id } }),
  twilioNumberPrice: (dealer_id?: number) => backendQueryKey<number>({ component, baseUrl: ENV.twilioBaseURL, endpoint: "/sub_accounts/price", params: { dealer_id } })
};
